<div class='remove-dropdown-toggle d-flex flex-row-reverse' container='body' ngbDropdown>
  <pt-icon (click)="clickMenu()" [key]='IconMenu' class='btn btn-sm' ngbDropdownToggle></pt-icon>
  <div ngbDropdownMenu>
    <ng-container *ngIf="loading">
      <div style="width: 160px; height: 200px; display: flex; align-items: center; justify-content: center;">
        <div class='d-flex flex-row justify-content-center align-items-center'>
          <div class='spinner-border spinner-border-sm' role='status'>
          </div>
          <span class='ms-1'>Loading...</span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!loading && !isEmptyVisibleAction">
      <ng-container *ngFor='let action of newActions index as idx'>
        <div *ngIf='action.visible' class="table-action">
          <hr *ngIf='action.separateFromAbove && idx > 0' class='table-action_separator my-2'>
          <pt-icon *ngIf='action.faIcon' [key]='action.faIcon' class='me-2'></pt-icon>
          <button (click)='emitAction.emit(action);' [disabled]='action.disabled'
                  class='btn-sm'
                  ngbDropdownItem
          >{{ action.label | async }}
          </button>
        </div>
      </ng-container>

    </ng-container>

    <ng-container *ngIf="!loading && isEmptyVisibleAction">
      <div class="no-operations-available"
           [innerHTML]="'LABELS.NO_OPERATIONS_AVAILABLE' | translate">
      </div>
    </ng-container>
  </div>
</div>
